const ResetModal = function () {
  this.multipleUserEdit.hideModal()
  this.multipleUserEdit.resetForm()
}

export default ResetModal
